import { render, staticRenderFns } from "./PlannedLimits.vue?vue&type=template&id=25edf521&scoped=true&"
import script from "./PlannedLimits.vue?vue&type=script&lang=ts&"
export * from "./PlannedLimits.vue?vue&type=script&lang=ts&"
import style0 from "./PlannedLimits.vue?vue&type=style&index=0&id=25edf521&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25edf521",
  null
  
)

export default component.exports